import React from 'react';
import Add from './svg/add';
import Cart from './svg/cart';
import Logo from './svg/logo';
import Edit from './svg/edit';
import Folder from './svg/folder';
import Cancel from './svg/cancel';
import Attach from './svg/attach';
import Print from './svg/print';
import AbstractLeft from './svg/abstract-left';
import AbstractRight from './svg/abstract-right';

const Icons = (props) => {
  switch (props.name) {
    case 'add':
      return <Add {...props} />;
    case 'cart':
      return <Cart {...props} />;
    case 'logo':
      return <Logo {...props} />;
    case 'edit':
      return <Edit {...props} />;
    case 'folder':
      return <Folder {...props} />;
    case 'cancel':
      return <Cancel {...props} />;
    case 'attach':
      return <Attach {...props} />;
    case 'print':
      return <Print {...props} />;
    case 'abstractLeft':
      return <AbstractLeft {...props} />;
    case 'abstractRight':
      return <AbstractRight {...props} />;
    default:
      return null;
  }
};

export default Icons;
